import { useSelector } from 'react-redux';

import { UnleashFeatureNames } from '../../../modules/Unleash/featureNames';
import { getIsFeatureEnabled } from '../../../selectors/features';
import { getSessionCompanyCountryCode } from '../../../selectors/session';

const PAYMENT_SYSTEM_V2_FLAG_BY_COUNTRY: Record<string, string> = {
  SG: UnleashFeatureNames.empAllUsePaymentSystemV2SG,
  ID: UnleashFeatureNames.empAllUsePaymentSystemV2ID,
};

export default function useIsPaymentSystemV2Enabled(): boolean {
  return useSelector(state => {
    const countryCode = getSessionCompanyCountryCode(state)?.toUpperCase();
    const flagName = countryCode
      ? PAYMENT_SYSTEM_V2_FLAG_BY_COUNTRY[countryCode]
      : undefined;

    return Boolean(flagName && getIsFeatureEnabled(state, flagName));
  });
}
